module.exports = __webpack_public_path__ + "img/kantar_art_chat_logo.e980d3d7.png";